<template>
  <div
    :style="{ width: width }"
    class="components-tabel"
    v-loading="tableLoading"
    element-loading-text="加载中..."
  >
    <div class="tabel-button-box">
      <div class="button-container">
        <slot></slot>
      </div>
      <div
        style="display: inline-block"
        v-if="newTabelButtons && newTabelButtons.length > 0"
      >
        <div
          class="button-container"
          style="display: inline-block"
          v-for="(i, index) in newTabelButtons"
          :key="index"
        >
          <BUTTON
            v-if="i.type === 'refresh'"
            :buttonCode="i.level ? '' : 'REFRESH'"
            :disabled="i.disabled"
            @clickEvent="i.fn()"
            :btnType="'success'"
          >
            {{ i.title ? i.title : "刷新" }}
          </BUTTON>
          <BUTTON
            v-if="i.type === 'add'"
            :buttonCode="i.level ? '' : 'ADD'"
            :disabled="i.disabled"
            @clickEvent="i.fn()"
            :btnType="'success'"
          >
            {{ i.title ? i.title : "新增" }}
          </BUTTON>
          <!-- 区域选择 -->
          <BUTTON
            v-if="i.type === 'districtArea'"
            :buttonCode="i.level ? '' : 'DISTRICTAREA'"
            :disabled="i.disabled"
            @clickEvent="i.fn()"
            :btnType="'warning'"
          >
            {{ i.title ? i.title : "区域选择" }}
          </BUTTON>
          <!-- 绑定用户 -->
          <BUTTON
            :buttonCode="i.level ? '' : 'BINDUSER'"
            v-if="i.type === 'bindUser'"
            :loading="i.loading"
            @clickEvent="i.fn()"
            :btnType="'warning'"
          >
            {{ i.title ? i.title : "绑定用户" }}
          </BUTTON>
          <!-- 关联相关 -->
          <BUTTON
            :buttonCode="i.level ? '' : 'RELEVANCY'"
            v-if="i.type === 'relevancy'"
            :loading="i.loading"
            :disabled="selectedData.length != 1 ? true : false"
            @clickEvent="i.fn()"
            :btnType="'warning'"
          >
            {{ i.title ? i.title : "关联" }}
          </BUTTON>
          <!-- 批量编辑 -->
          <BUTTON
            :buttonCode="i.level ? '' : 'EDIT'"
            v-if="i.type === 'edit'"
            :loading="i.loading"
            :disabled="selectedData.length <= 0 ? true : false"
            @clickEvent="i.fn(selectedData)"
            :btnType="'success'"
          >
            {{ i.title ? i.title : "批量编辑" }}
          </BUTTON>

          <!-- 批量删除 -->
          <BUTTON
            :buttonCode="i.level ? '' : 'DEL'"
            v-if="i.type === 'delete'"
            :loading="i.loading"
            :disabled="selectedData.length <= 0 ? true : false"
            @clickEvent="batchData(i)"
            :btnType="'danger'"
          >
            {{ i.title ? i.title : "批量删除" }}
          </BUTTON>
          <!-- 批量禁用 -->
          <BUTTON
            :buttonCode="i.level ? '' : 'FORBIDDEN'"
            v-if="i.type === 'forbidden'"
            :loading="i.loading"
            :disabled="selectedData.length <= 0 ? true : false"
            @clickEvent="i.fn(selectedData)"
            :btnType="'danger'"
          >
            {{ i.title ? i.title : "批量禁用" }}
          </BUTTON>
          <!-- 授权或者批量授权 -->
          <BUTTON
            :buttonCode="i.level ? '' : 'BATCHIMPOWER'"
            v-if="i.type === 'batchImpower'"
            :loading="i.loading"
            :disabled="selectedData.length <= 0 ? true : false"
            @clickEvent="i.fn()"
            :btnType="'warning'"
          >
            {{ i.title ? i.title : "批量授权" }}
          </BUTTON>
          <BUTTON
            :buttonCode="i.level ? '' : 'IMPOWER'"
            v-if="i.type === 'impower'"
            :loading="i.loading"
            :disabled="selectedData.length != 1 ? true : false"
            @clickEvent="i.fn(selectedData)"
            :btnType="'warning'"
          >
            {{ i.title ? i.title : "用户授权" }}
          </BUTTON>
          <!--批量审核-->
          <!-- 区域认证——批量授权 -->
          <BUTTON
            :buttonCode="i.level ? '' : 'AUDIT'"
            v-if="i.type === 'batchAudit'"
            :loading="i.loading"
            :disabled="selectedData.length <= 0 ? true : false"
            @clickEvent="i.fn(selectedData)"
            :btnType="'warning'"
          >
            {{ i.title ? i.title : "审核" }}
          </BUTTON>

          <!-- 导入 -->
          <div class="button-box" v-if="i.type === 'upload'">
            <input
              ref="uploadFileM"
              type="file"
              @change="
                upload($event, i.path, i.paramsName, i.fn, i.accept, i.hint)
              "
              :accept="i.accept"
            />
            <BUTTON :buttonCode="'IMPORT'" :iconName="'el-icon-upload2'">
              {{ i.title ? i.title : "导入" }}
            </BUTTON>
          </div>

          <BUTTON
            v-if="i.type === 'download'"
            :buttonCode="'EXPORT'"
            @clickEvent="derive(i.path)"
            :iconName="'el-icon-download'"
          >
            <a style="color: #fff" :href="downLoadPath" target="_self">{{
              i.title ? i.title : "导出"
            }}</a>
          </BUTTON>
          <!-- 批量编辑 -->
          <BUTTON
              v-if="i.type === 'viewUrl'"
              :loading="i.loading"
              :disabled="selectedData.length <= 0 ? true : false"
              @clickEvent="i.fn(selectedData)"
              :btnType="'success'"
          >
            {{ i.title ? i.title : "生成地址" }}
          </BUTTON>
          <BUTTON
              v-if="i.type === 'areaUrl'"
              :loading="i.loading"
              @clickEvent="i.fn()"
              :btnType="'success'"
          >
            {{ i.title ? i.title : "区域生成地址" }}
          </BUTTON>

          <!-- 导出 -->
          <BUTTON
            v-if="i.type === 'downloadBlod'"
            :buttonCode="'EXPORT'"
            :iconName="'el-icon-download'"
            @clickEvent="downLoad(i.path, i.fn, i.hint, i.fileName)"
          >
            <a :href="downLoadPath" target="_self">{{
              i.title ? i.title : "导出"
            }}</a>
          </BUTTON>
        </div>
      </div>
    </div>
    <el-table
      :size="tableConfig.size || 'small'"
      ref="multipleTable"
      :data="templateData"
      tooltip-effect="dark"
      border
      :stripe="true"
      :height="tableConfig.height?tableConfig.height:'100%'"
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column v-if="tableConfig.checkbox" type="selection">
      </el-table-column>
      <el-table-column label="序号" v-if="tableConfig.index" width="70px">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- :show-overflow-tooltip="true" -->
      <el-table-column
        v-for="(i, index) in tableConfig.rows"
        :key="index"
        :width="i.width"
        :prop="i.prop"
        :label="i.label"
      >
        <template slot-scope="scope">
          <div v-if="i.type === 'switch' && showButton(scope.row, i.show)">
            <span
              v-if="i.showWord || true"
              style="display: inline-block; width: 50px"
              :style="{
                color: scope.row[i.prop] ? 'rgb(19, 206, 102)' : '#cecece',
                marginRight: '10px',
              }"
              >{{ scope.row[i.prop] ? "启用" : "禁用" }}</span
            >
            <el-switch
              :disabled="isDisabled(scope.row, i.disabled)"
              @change="i.fn ? i.fn(scope.row[i.prop], scope.row) : ''"
              v-model="scope.row[i.prop]"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
          <div
            v-if="i.type === 'activeStatus' && showButton(scope.row, i.show)"
          >
            <span>{{ i.fn(scope.row) }}</span>
          </div>
          <!-- 按钮到处-->
          <!--i.style?i.style:null-->
          <el-button
            :style="{ color: i.color }"
            v-else-if="i.type === 'button' && showButton(scope.row, i.show)"
            size="mini"
            :type="btnType(scope.row, i.prop)"
            @click="getRowData(i, scope, $event)"
          >
            {{ scope.row[i.prop] ? i.activeText : i.text }}
          </el-button>
          <div
            :style="{ color: i.color }"
            v-else-if="i.type === 'status' && showButton(scope.row, i.show)"
            :class="i.fn ? 'toblue' : ''"
            @click="getRowData(i, scope, $event)"
            v-html="scope.row[i.prop] ? i.activeText : i.text"
          ></div>
          <div
            :style="{ color: i.color }"
            v-else-if="i.type === 'text' && showButton(scope.row, i.show)"
            :class="i.fn ? 'toblue' : ''"
            @click="getRowData(i, scope, $event)"
            v-html="i.template || scope.row[i.prop]"
          ></div>
          <!-- 是否绑定 -->
          <div
            v-else-if="i.type === 'isBind' && showButton(scope.row, i.show)"
          >
            <span class="bindStyle" v-if="scope.row[i.prop]">已绑定</span>
            <span class="nobindStyle" v-else @click="getRowData(i, scope, $event)">未绑定</span>
          </div>
          <!-- 授权状态显示 -->
          <div
            :style="{ color: i.color }"
            v-else-if="i.type === 'accessText' && showButton(scope.row, i.show)"
            :class="i.fn ? 'toblue' : ''"
            @click="getRowData(i, scope, $event)"
            v-html="
              i.template ||
              (scope.row.status === 1
                ? '申请中'
                : scope.row.status === 2
                ? '已通过'
                : scope.row.status === 3
                ? '已拒绝'
                : scope.row.status === 4
                ? '已解绑'
                : '手动授权')
            "
          ></div>
          <!--评星-->
          <div
            class=""
            v-else-if="i.type === 'rate' && showButton(scope.row, i.show)"
          >
            <el-popover
              placement="top-start"
              title="评价详情"
              width="200"
              trigger="hover"
              :content="scope.row[i.propContent] != null?scope.row[i.propContent]:'暂无评价详情！'"
            >
              <el-rate
                v-if="scope.row[i.prop] != null"
                :colors="colors"
                :disabled="true"
                slot="reference"
                v-model="scope.row[i.prop]"
              >
              </el-rate>
              <el-button
                v-else
                type="text"
                slot="reference"
                @click="getRowData(i, scope, $event)"
              ></el-button>
            </el-popover>
          </div>
          <div
            :style="{ color: i.color }"
            v-else-if="
              (!i.type || i.type === 'text') && showButton(scope.row, i.show)
            "
            :class="i.fn ? 'toblue' : 'normal-text'"
            @click="getRowData(i, scope, $event)"
            v-html="i.template || scope.row[i.prop]"
          ></div>

          <el-popover
            v-else-if="
              (!i.type || i.type === 'popover') && showButton(scope.row, i.show)
            "
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row[i.prop]"
          >
            <span
              class="popover-style"
              :style="{ width: i.width + 'px' }"
              slot="reference"
              >{{ scope.row[i.prop] }}</span
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        :width="tableConfig.rowButtons.width"
        v-if="
          tableConfig.rowButtons &&
          tableConfig.rowButtons.items &&
          tableConfig.rowButtons.items.length > 0
        "
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <div
              style="display: inline-block"
              v-for="(i, index) in tableConfig.rowButtons.items"
              :key="index"
            >
              <div
                style="display: inline-block"
                v-if="
                  !tableConfig.rowButtons.type ||
                  tableConfig.rowButtons.type === 'normal'
                "
              >
                <BUTTON
                  style="margin-right: 5px"
                  v-if="showButton(scope.row, i.show, i.showkey)"
                  :disabled="
                    isDisabledTabelButton(scope.row, i.disabled, i.type)
                  "
                  @clickEvent="i.fn(scope.row)"
                  :btnType="i.type"
                  size="mini"
                  :label="i.label"
                  :iconName="i.icon"
                  :buttonCode="i.code"
                  :color="i.color"
                >
                  {{ i.label }}
                </BUTTON>
              </div>
              <div
                style="display: inline-block"
                v-if="tableConfig.rowButtons.type === 'plain'"
              >
                <span
                  class="row-btn"
                  v-if="showButton(scope.row, i.show)"
                  :disabled="
                    isDisabledTabelButton(scope.row, i.disabled, i.type)
                  "
                  @click="
                    !isDisabledTabelButton(scope.row, i.disabled, i.type)
                      ? i.fn(scope.row)
                      : ''
                  "
                  :btnType="i.type"
                  :class="[
                    i.icon,
                    isDisabledTabelButton(scope.row, i.disabled, i.type)
                      ? 'gray'
                      : '',
                  ]"
                  :buttonCode="i.code"
                >
                  {{ i.label }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :style="{ textAlign: pagination.align || 'right' }"
      v-if="pagination && pagination.show"
      :small="pagination.small || false"
      @size-change="pagination.sizeChange"
      @current-change="pagination.pageChange"
      :current-page="pagination.page || 1"
      :page-sizes="pagination.pageSizes || [15, 20, 30]"
      :page-size="pagination.size || 15"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total || 0"
    >
    </el-pagination>
  </div>
</template>

<script>
import BUTTON from "../Button/Button";
import publicFn from "../../assets/js/publicFn.js";
export default {
  name: "powerTable",
  components: { BUTTON },
  props: [
    "tabelButtons",
    "pagination",
    "templateData",
    "tableData",
    "tableConfig",
    "width",
    "tableLoading",
  ],
  data() {
    return {
      downLoadPath: "",
      checkList: [],
      inputSort: false,
      inputLoc: false,
      locSelected: [],
      sortSelected: [],
      selectedData: [],
      newTabelButtons: [], //权限筛选后的button
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"], // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
    };
  },
  created() {
    this.tabelButtons
      ? this.tabelButtons.map((item) => {
          if (item.level == "addBroadcast") {
            if (publicFn.checkButton(item.level)) {
              this.newTabelButtons.push(item);
            }
          } else {
            this.newTabelButtons.push(item);
          }
        })
      : "";
  },
  mounted() {
    this.initSelectData();
  },
  methods: {
    // 初始化下拉框的数据
    initSelectData() {
      for (let i of this.tableConfig.rows) {
        if (i.type === "select" && i.path && !i.data) {
          this.$http.get(i.path).then((res) => {
            if (res.status === 200) {
              if (res.result.__proto__ === Array.prototype) {
                this.$set(i, "data", res.result);
              } else {
                this.$set(i, "data", res.result.pageList);
              }
            }
          });
        }
      }
    },
    /*--------------批量操作-----------------------*/
    batchData(config) {
      if (this.selectedData.length <= 0) {
        this.$message.info("提示：请选中一条数据进行修改");
        return;
      }

      let paramsName = config.paramsName.replace(/\s+/g, ""); //去空格
      let keyValue = paramsName.split(":"); // 获取自定义参数的key value名称

      let params = {
        // 自定义参数
        [keyValue[0]]: [],
      };
      this.selectedData.forEach((item) => {
        params[keyValue[0]].push(item[keyValue[1]]);
      });
      let path = config.path;
      let qs = require("qs");
      let urlSearch = ""; // 固定参数
      let urlData;
      if (path.indexOf("?") !== -1) {
        urlSearch = path.slice(path.indexOf("?") + 1, path.length);
        path = path.slice(0, path.indexOf("?"));
        urlData = qs.parse(urlSearch, { ignoreQueryPrefix: true });
        for (let i in urlData) {
          // 转换为boolean
          if (urlData[i] === "true" || urlData[i] === "false") {
            urlData[i] = urlData[i] === "true" ? true : false;
          }
        }
      }
      params = { ...params, ...urlData };
      this.open("warning", config, params);
    },

    /*--------------------- 批量提交 -----------------*/
    open(type, config, params) {
      this.$confirm(config.hintMessage || "确认进行该操作嘛？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          this.$http.post(config.path, params).then((res) => {
            this.selectedData = [];
            this.$message.success(res.msg || "操作成功");
            if (config.fn) {
              config.fn();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /*--------------------上传-----------------------*/
    upload(e, path, name, fn, accept, hint) {
      const file = e.target.files[0];
      console.log(file);
      if (accept.indexOf(file.type) === -1) {
        this.$message.error("请上传正确的格式");
        return false;
      }

      const form = new FormData();
      form.append("file", file);

      this.$http.post(path, form).then((res) => {
        if (res.status == 200) {
          e.target.value = "";
          this.$message.success(res.msg || hint || "上传成功");
          if (fn) {
            fn();
          }
        } else {
          this.$message.error(res.result[0].erMsg || hint || "上传失败");
          e.target.value = "";
        }
      });
    },
    /*--------------------导出-----------------------*/
    derive(path) {
      this.downLoadPath = path;
      // window.open(path);
    },
    /*-----------------------下载-------------------*/
    downLoad(path) {
      // , fn, hint, fileName
      // let qs = require('qs')
      // let urlSearch = '' // 固定参数
      // let requestPath = path // 请求路径
      // let urlData = {}
      // if(requestPath.indexOf('?') !== -1) {
      //     urlSearch = requestPath.slice(requestPath.indexOf('?') + 1, requestPath.length)
      //     requestPath = requestPath.slice(0, requestPath.indexOf('?'))
      //     urlData = qs.parse(urlSearch, { ignoreQueryPrefix: true })
      //     for(let i in urlData) {  // 转换为boolean
      //         if (urlData[i] === 'true' || urlData[i] === 'false') {
      //             urlData[i] = urlData[i] === 'true' ? true : false
      //         }
      //     }
      // }
      // console.log(path);
      this.$http.get(path, { responseType: "arraybuffer" }).then((res) => {
        this.downLoadPath = res;
        // return res;
        // window.open(res)
        // const data = res.data
        // const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        // const link = document.createElement('a')
        // link.style.display = 'none'
        // link.href = url
        // link.setAttribute('download', fileName || '导出.xlsx')
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link)
        // this.$message.success(res.msg || hint || '下载成功')
        //
        // if(fn) {
        //     fn()
        // }
      });
    },

    /*---------------------回调---------------------*/
    // 选中 and 全选
    handleSelectionChange(val) {
      this.selectedData = val;
      this.tableConfig.checkboxFn(val);
    },
    // 具有函数的td，点击回调
    getRowData(i, scope, e) {
      const path = e.path;
      if(path){
        path.forEach((item) => {
          if (item.getAttribute && item.getAttribute("id")) {
            const id = item.getAttribute("id");
            if (i.clickDom) {
              i.clickDom.forEach((obj) => {
                if (obj.id === id && obj.fn) {
                  const tagName = item.tagName;
                  const TextDom = [
                    "SPAN",
                    "DIV",
                    "P",
                    "H1",
                    "H2",
                    "H3",
                    "H4",
                    "H5",
                    "H6",
                  ];
                  const mediaDom = ["IMG", "VIDEO", "AUDEO", "BUTTON"];
                  let callbackArguments = { tagName: tagName };
                  if (mediaDom.includes(tagName)) {
                    callbackArguments[id] = item.getAttribute("src");
                  }

                  if (TextDom.includes(tagName)) {
                    callbackArguments[id] = item.innerText;
                  }
                  obj.fn(callbackArguments, scope.row);
                }
              });
            }
          }
        });
      }
      if (i.fn) {
        i.fn(scope.row, scope.$index);
      }
    },
    /*-------------------按钮typ规则---------------------*/
    btnType(data, type) {
      if (type) {
        return data[type] == true ? "primary" : "danger";
      } else {
        return null;
      }
    },
    /*-------------------渲染规则---------------------*/
    // 是否显示表单button
    showButton(data, show, showkey) {
      if (show) {
        show = show.replace(/\s+/g, "");
        let params = show.slice(0, show.indexOf("="));
        let params1 = show.slice(show.indexOf("="), show.length);
        return eval(`data.${params}${params1}`);
        // return false;
      } else {
        if (showkey) {
          return data[showkey];
        } else {
          return true;
        }
      }
    },

    // 是否禁用表单button
    isDisabledTabelButton(data, disable) {
      if (typeof disable === "undefined") {
        return false;
      }
      if (typeof disable === "boolean") {
        return disable;
      }
      disable = disable.replace(/\s+/g, "");
      let params = disable.slice(0, disable.indexOf("="));
      let params1 = disable.slice(disable.indexOf("="), disable.length);
      return eval(`data.${params}${params1}`);
    },
    // 是否禁止全局button
    isDisabled(data, show) {
      if (this.$route.query.disabled) {
        return true;
      } else {
        if (show) {
          show = show.replace(/\s+/g, "");
          let params = show.slice(0, show.indexOf("="));
          let params1 = show.slice(show.indexOf("="), show.length);
          return eval(`data.${params}${params1}`);
        } else if (this.tableConfig.disabled) {
          return this.tableConfig.disabled;
        } else {
          return false;
        }
      }
    },
    //按钮属性判断
  },
};
</script>

<style lang="less">
@import "table.less";
</style>
